import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { Col, Descriptions, Row, Typography } from 'antd'
import { useCallback, useState } from 'react'
import { COLOR, AWS_S3_URL } from '../../constants'
import { D4_Evenementdemande_Set_Input, D4_Fn_View_Evenements } from '../../types'
import Thumbnail from '../Thumbnail'

const DemandeContentItem = ({
  item,
  updateEvent,
  currentUserId,
}: {
  item: D4_Fn_View_Evenements
  updateEvent: (variables: { variables: { id: number; data: D4_Evenementdemande_Set_Input } }) => void
  currentUserId: number
}) => {
  const [editing, setEditing] = useState(false)
  const handleEditText = useCallback(
    (text: string) => {
      updateEvent({ variables: { id: item.id, data: { texte: text } } })
      setEditing(false)
    },
    [item.id, updateEvent]
  )

  const text = item.interventionobjet ?? item.demandedevisobjet ?? item.texte ?? item.texte

  return (
    <div
      style={{
        backgroundColor: COLOR.white,
        padding: 5,
        margin: 0,
        border: `1px solid rgba(0, 0, 1, .15)`,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {item.fichier ? <Thumbnail texte={item.texte} /> : null}
      <div>
        {item.auteurid === currentUserId && !item.fichier ? (
          <Typography.Paragraph
            style={{ width: '100%', whiteSpace: 'pre-wrap' }}
            editable={{
              onChange: handleEditText,
              onStart: () => setEditing(true),
            }}
          >
            {editing ? text : text && <span dangerouslySetInnerHTML={{ __html: text }} />}
          </Typography.Paragraph>
        ) : (
          <>
            <Typography.Paragraph style={{ width: '100%', whiteSpace: 'pre-wrap' }}>
              {text && (
                <Row gutter={[12, 12]} justify="space-between" align="middle">
                  <Col span={24}>
                    <span dangerouslySetInnerHTML={{ __html: text }} />
                  </Col>
                  {item.fichier === 1 && (
                    <Col>
                      <a href={`${AWS_S3_URL}${item.texte}`} target="_blank" rel="noreferrer">
                        Ouvrir dans un onglet
                      </a>
                    </Col>
                  )}
                </Row>
              )}
            </Typography.Paragraph>
          </>
        )}
        {item.form && (
          <Row gutter={[12, 12]} justify="space-between" align="middle">
            <Col>
              <Descriptions title="Informations" bordered column={1} size="small">
                {item.form.data.map((field: any) => (
                  <Descriptions.Item
                    key={field.name}
                    label={
                      <div>
                        <div>{field.name}</div>
                        <Typography.Text italic type="secondary">
                          {field.description}
                        </Typography.Text>
                      </div>
                    }
                  >
                    {typeof field.value === 'object'
                      ? Object.entries(field.value).map((key) => (
                          <span key={key[0]}>
                            {key} : {key[1] ? <CheckOutlined /> : <CloseOutlined />}
                          </span>
                        ))
                      : field.value}
                  </Descriptions.Item>
                ))}
              </Descriptions>
            </Col>
          </Row>
        )}
      </div>
    </div>
  )
}

export default DemandeContentItem
